<template>
  <div class="b-logo" :class="`_${type}`">
    <b-svg-icon name="saipient-logo-simple" />
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    type?: 'dark' | 'light';
  }>(),
  {
    type: 'light'
  }
);
</script>

<style lang="postcss">
.b-logo {
  &._light {
    @apply text-white;
  }

  .icons {
    @apply h-[48px] w-[151px];
  }
}
</style>
